#import "../fragments/text-automation-fragment.graphql"

query GetTextAutomationsByStage($stageId: ID!) {
    textAutomations(stageId: $stageId) {
        ...TextAutomation
    }
}
